<template>
  <div style="clear: both">
    <v-card class="white" max-width="1200" light>
      <v-container fluid>
        <v-toolbar dense density="compact" :elevation="8">
          <v-toolbar-title>
            <template v-if="isItSupport">
              {{ task.name }} -- (ITSupport Data) ChangeType: <strong>{{ task.relatedChangeType }}</strong> - taskId:
              <strong>{{ task.taskId }}</strong>
            </template>
            <template v-else>{{ task.name }}</template>
          </v-toolbar-title>
        </v-toolbar>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-select
              :label="$t('Status')"
              :items="sortedItemStatus"
              item-title="name"
              item-value="name"
              clearable
              @update:model-value="handleTaskChange(task, $event)"
              return-object
              variant="underlined"
              :model-value="task.status ? task.status.name : null"
              @click:clear.stop="clearStatus()"
              :error-messages="task.completed === true ? null : $t('Rule_Task_Must_Be_Satisfied')"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-textarea
              :label="$t('Comments')"
              auto-grow
              rows="1"
              variant="underlined"
              v-model="task.comment"
              @update:model-value="handleCommentsChange($event)"
            ></v-textarea>
          </v-col>
        </v-row>
        
        <v-row dense>
          <v-col cols="12" sm="6">
            <people-picker
              v-model="task.assignedTo"
              :includeDistroService="true"
              name="assignedTo"
              :label="$t('Assigned_To')"
              :user="taskAssignedTo"
              :inUser="taskAssignedTo"
              @clear="clearAssignedTo"
              v-on:update:model-value="outAssignedTo($event)"
            ></people-picker>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6">
            <people-picker v-model="completedBy" :label="$t('Completed_By')" :user="task.completedBy" readonly></people-picker>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field :label="$t('Completed_Date')" variant="underlined" :model-value="$filters.DateFilter(task.completedDate)" readonly dense></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="2">
            <v-text-field :label="$t('Step')" variant="underlined" :model-value="task.step" readonly> </v-text-field>
          </v-col>
          <v-col cols="12" sm="10">
            <v-text-field
              :label="$t('Required_In_Order_To')"
              variant="underlined"
              :model-value="taskListTypeToString(task.taskListType)"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>

        <template
          v-if="(task.supportingLinks ? task.supportingLinks.length : 0) > 0 || (task.standards ? task.standards.length : 0) > 0"
        >
          <v-row dense>
            <template v-if="(task.supportingLinks ? task.supportingLinks.length : 0) > 0">
              <v-col cols="6">
                <v-expansion-panels accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-title>
                      <template v-slot:default="{ open }">
                        <v-row no-gutters>
                          <v-col cols="12">
                            {{ $t('Supporting_Links') }} ( {{ task.supportingLinks ? task.supportingLinks.length : 0 }} )</v-col
                          >
                        </v-row>
                      </template>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      <v-list dense>
                        <v-list-item
                          v-for="(link, index) in task.supportingLinks"
                          :key="index"
                          @click.stop
                          :href="'//' + link.url"
                          target="_blank"
                        >
                          
                            {{ link.name }}
                          
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </template>

            <template v-if="(task.standards ? task.standards.length : 0) > 0">
              <v-col cols="6">
                <v-expansion-panels accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-title>
                      <template v-slot:default="{ open }">
                        <v-row no-gutters>
                          <v-col cols="12"> {{ $t('Standards') }} ( {{ task.standards ? task.standards.length : 0 }} )</v-col>
                        </v-row>
                      </template>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      <v-list dense>
                        <v-list-item
                          v-for="(standard, index) in task.standards"
                          :key="index"
                          @click.stop
                          :href="'//' + standard.url"
                          target="_blank"
                        >
                          
                            {{ standard.name }}
                          
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </template>
          </v-row>
        </template>

        <v-row>
          <v-col cols="12">
            <task-history :history="task.history"></task-history>
          </v-col>
        </v-row>

        <template v-if="task.addedVia === 'manual'">
          <v-row justify="end" class="mr-2">
            <span>
              {{ $t('Manual_Task_Added_By') }}: {{ task.insertedBy.displayName }} - {{ $filters.DateTimeFilter(task.insertedByDate) }}
            </span>
          </v-row>
        </template>

        <v-row justify="end" class="mr-2">
          <span> {{ $t('Last_Modified_By') }}: {{ task.modifiedBy.displayName }} - {{ $filters.DateTimeFilter(task.modifiedByDate) }} </span>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
import { mapState } from 'vuex'
import { TaskListTypes } from '@/common/types'
import { multiPropertySort } from '@/common/arrayFunctions'
import { Flag } from '@/common/task'
import { EventBus } from '@/common/event-bus'
import TaskHistory from '@/components/task/TaskHistory'
export default {
  name: 'Task',
  data() {
    return {
      assignedTo: null,
      completedBy: null
    }
  },
  props: {
    task: {
      type: Object,
      default: null
    }
  },
  components: {
    PeoplePicker,
    TaskHistory
  },
  computed: {
    ...mapState('personalSettings', ['dark']),
    ...mapState('currentUser', ['user']),
    ...mapState('currentUserAdminRoles', ['adminRoles']),
    taskAssignedTo: function () {
      return this.task.assignedTo
    },
    isItSupport() {
      return this.adminRoles.find((x) => x === 'ITSupport')
    },
    sortedItemStatus: function () {
      let sortBy = [{ prop: 'displayOrder', direction: 1 }]
      if (this.task.itemStatus) {
        let sorted = multiPropertySort(sortBy, this.task.itemStatus)
        return sorted
      }
      return null
    },
    completedDate: {
      cache: false,
      get: function () {
        return this.task.completedDate
      },

      set: function (val) {
        this.task.completedDate = val
      }
    }
  },
  methods: {
    clearAssignedTo: function () {
      //  this.task.assignedTo = null
      this.task.assignedTo = {}
    },
    clearStatus: function () {
      this.setCompletedDate(null)
      this.task.completed = false

      this.task.status = { name: null, value: null }
      this.task.completedBy = null
      this.task.flag = Flag.DIRTY

      this.$emit('completed', false)
      EventBus.emit('taskStatusChange', false)
      this.$forceUpdate()
    },
    gotoExternalLink: function (link) {
      location.href = link
    },
    handleCommentsChange: function () {
      this.task.flag = Flag.DIRTY
    },
    handleTaskChange: function (task, selectedItem) {
      if (!selectedItem) {
        return
      }

      let completed = false
      let _completedDate = null

      // status "required" met (task complete)
      if (selectedItem.required) {
        _completedDate = new Date().toISOString()
        completed = true
        this.task.completedBy = this.user
        this.task.flag = Flag.DIRTY
      }
      // status "required" not met (task not complete)
      if (!selectedItem.required) {
        completed = false
        this.task.completedBy = null
        this.task.flag = Flag.DIRTY
      }

      this.task.status = { name: selectedItem.name, value: completed ? 'Completed' : null }
      this.setCompletedDate(_completedDate)

      this.task.completed = completed

      this.$emit('completed', completed)
      EventBus.emit('taskStatusChange', completed)
      this.$forceUpdate()
    },
    outAssignedTo: function (val) {
      if (val) {
        this.task.assignedTo = val
        this.$emit('taskAssignedTo', val)
      }
    },
    setCompletedDate: function (date) {
      this.task.completedDate = date
      this.completedDate = date
    },
    taskListTypeToString: function (typeKey) {
      if (typeKey.key) {
        return TaskListTypes.properties[typeKey.key].value
      }
      return null
    }
  },
  watch: {
    assignedTo(newValue) {
      if (newValue) {
        this.task.assignedTo = newValue
        this.task.flag = Flag.DIRTY
      }
    }
  }
}
</script>
<style scoped>
a {
  text-decoration: none;
}
</style>
